import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

const getSocketToken = () => {
  let storedToken = "";

  try {
    storedToken = localStorage.getItem("token");
  } catch (_err) {
    return "";
  }

  if (!storedToken) {
    return "";
  }

  try {
    return JSON.parse(storedToken);
  } catch (_err) {
    return storedToken;
  }
};

const getSocketConnectionConfig = () => {
  const backendUrl = getBackendUrl();
  const currentHost = window.location.hostname;
  const isLocalDevelopmentHost =
    currentHost === "localhost" || currentHost === "127.0.0.1";

  // In production/PWA installs, always connect through the same origin
  // so the browser uses wss when the page is on https.
  if (!isLocalDevelopmentHost) {
    return {
      url: window.location.origin,
      path: "/socket.io"
    };
  }

  try {
    const parsedUrl = new URL(backendUrl, window.location.origin);
    return {
      url: parsedUrl.origin,
      path: "/socket.io"
    };
  } catch (_err) {
    return {
      url: window.location.origin,
      path: "/socket.io"
    };
  }
};

function connectToSocket() {
  const token = getSocketToken();
  const { url, path } = getSocketConnectionConfig();

  return openSocket(url, {
    path,
    transports: ["polling", "websocket"],
    withCredentials: true,
    secure: window.location.protocol === "https:",
    timeout: 20000,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    upgrade: true,
    rememberUpgrade: false,
    query: {
      token
    }
  });
}

export default connectToSocket;